;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Anchor } from '@qogita/ui/v2/anchor'
import { ComponentPropsWithRef } from 'react'
import { useSignature } from 'src/deprecated/contexts/Authentication'
import { env } from 'src/env.mjs'

/** @deprecated use AnchorWithSignature from src/components/anchor-with-signature instead */
export const AnchorWithSignatureDeprecated = ({
  href,
  ...rest
}: Omit<ComponentPropsWithRef<typeof Anchor>, 'href'> & { href: string }) => {
  const signature = useSignature()
  let hrefWithSignature = `${env.NEXT_PUBLIC_API_BASE_URL}${href}`
  if (signature) {
    if (href.toString().includes('?')) {
      hrefWithSignature += `&signature=${signature}`
    } else {
      hrefWithSignature += `?signature=${signature}`
    }
  }
  return <Anchor download href={hrefWithSignature} {...rest} />
}

export const AnchorWithSignature = ({
  href,
  ...rest
}: ComponentPropsWithRef<typeof Anchor>) => {
  const signature = useSignature()
  let hrefWithSignature = `${env.NEXT_PUBLIC_API_BASE_URL}${href}`
  if (signature) {
    if (href.toString().includes('?')) {
      hrefWithSignature += `&signature=${signature}`
    } else {
      hrefWithSignature += `?signature=${signature}`
    }
  }
  return <Anchor download href={hrefWithSignature} {...rest} />
}
